document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".se-select").forEach(function (selectEl) {
    var productId = selectEl.dataset.product;
    var form = document.querySelector('.se-product-form[data-product="' + productId + '"]');
    var hiddenInput = form ? form.querySelector('input.se-variant-id[data-product="' + productId + '"]') : null;
    var priceSpans = document.querySelectorAll('.se-custom-price[data-product="' + productId + '"]');
    function setActivePrice(variantId) {
      priceSpans.forEach(function (priceSpan) {
        if (priceSpan.dataset.variant === String(variantId) && priceSpan.dataset.product === productId) {
          priceSpan.classList.add("se-custom-price-active");
        } else {
          priceSpan.classList.remove("se-custom-price-active");
        }
      });
    }
    if (selectEl.value && hiddenInput && hiddenInput.value !== selectEl.value) {
      hiddenInput.value = selectEl.value;
      setActivePrice(hiddenInput.value);
    } else {
      setActivePrice(hiddenInput ? hiddenInput.value : selectEl.value);
    }
    selectEl.addEventListener("change", function () {
      if (hiddenInput) hiddenInput.value = this.value;
      setActivePrice(hiddenInput ? hiddenInput.value : this.value);
    });
  });
});

(function(){
  function whenUpcartReady(cb){
    if (typeof window.upcartOpenCart === "function" || typeof window.upcartRegisterAddToCart === "function") return cb();
    var tries = 0, t = setInterval(function(){
      if (typeof window.upcartOpenCart === "function" || typeof window.upcartRegisterAddToCart === "function"){
        clearInterval(t); cb();
      } else if (++tries > 100) {
        clearInterval(t);
      }
    }, 100);
  }
  function openUpcart(){
    if (typeof window.upcartRegisterAddToCart === "function") { try { window.upcartRegisterAddToCart(); } catch(e){} return; }
    if (typeof window.upcartOpenCart === "function") { try { window.upcartOpenCart(); } catch(e){} return; }
  }
  function scheduleOpen(){
    whenUpcartReady(openUpcart);
    setTimeout(function(){ whenUpcartReady(openUpcart); }, 200);
    setTimeout(function(){ whenUpcartReady(openUpcart); }, 600);
  }
  function addViaAjax(form, btn){
    if (btn && btn.dataset.seBusy === "1") return;
    if (btn) btn.dataset.seBusy = "1";
    var idInput = form.querySelector('input.se-variant-id[name="id"]') || form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var id = idInput ? idInput.value : null;
    var qty = qtyInput && qtyInput.value ? parseInt(qtyInput.value,10) : 1;
    if (!id) { if (btn) btn.dataset.seBusy = ""; return; }
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:id,quantity:isNaN(qty)?1:qty}]})
    }).then(function(r){return r.ok?r.json():r.json().then(function(x){throw x;});})
      .then(function(){
        if (btn) btn.dataset.seBusy = "";
        scheduleOpen();
        document.dispatchEvent(new CustomEvent('se:cart:added',{detail:{variantId:id,quantity:qty}}));
      })
      .catch(function(){
        if (btn) btn.dataset.seBusy = "";
      });
  }
  function onTrigger(e){
    var btn = e.target.closest('.se-product-trigger');
    if (!btn) return;
    var form = btn.closest('form.se-product-form');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addViaAjax(form, btn);
  }
  function bind(){
    var btns = document.querySelectorAll(".se-product-trigger");
    for (var i=0;i<btns.length;i++){
      btns[i].addEventListener("touchend", onTrigger, { capture:true });
      btns[i].addEventListener("click", onTrigger, true);
    }
    var forms = document.querySelectorAll(".se-product-form.product-form");
    for (var j=0;j<forms.length;j++){
      forms[j].addEventListener("submit", function(ev){
        ev.preventDefault();
        ev.stopImmediatePropagation();
        addViaAjax(this, this.querySelector('.se-product-trigger'));
      }, true);
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
  window.upcartOnCartOpened = window.upcartOnCartOpened || function(){};
})();
